<template>
  <Banner v-if="!route.meta.hideBanner"/>
  <router-view />
  <Footer v-if="!route.meta.hideFooter"/>
</template>
<script setup>
import Banner from '@/components/banner.vue'
import Footer from '@/components/footer.vue'
import { useRoute } from 'vue-router'
const route = useRoute()
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.content {
  width: 100%;
  margin: 15px auto 15px;
  padding: 0 3%;
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
}

input {
  border: none;
  outline: none;
}
body {
  overflow-x: hidden;
  max-width: 100vw;
  -webkit-font-smoothing: antialiased;
  background-color: #fff;
}

body::-webkit-scrollbar {
  width: 5px;
  background-color: #e0f8ff;

}

body::-webkit-scrollbar-thumb {
  width: 4px;
  background-color: #6fa5fc;
}
</style>
